export const FORM_REG_EX = /([a-z])([A-Z])/g;
export const FORM_REG_EX_REPLACER = '$1 $2';

export const NUMBER_REG_EX = /[^0-9]+/g;
export const DECIMAL_REG_EX = /^\d+(\.\d{0,2})?$/;
